export const gossipTestimonials = [
  {
    name: "苏晚",
    role: "通勤党 · 使用一年",
    quote:
      "早上挤地铁的时候刷一遍「今日更新」，基本就知道昨天到今天发生了什么，不用再去几个平台来回跳，省心很多。",
  },
  {
    name: "陈默",
    role: "学生 · 使用八个月",
    quote:
      "最喜欢的是它会写清楚哪条是确认的、哪条只是传闻。以前看热闹容易被带偏，现在至少知道自己在看什么。",
  },
  {
    name: "林一苇",
    role: "自由职业者 · 使用两年",
    quote:
      "热搜榜和分类页配合着看很顺，想追某个话题就直接进分类，不会像刷短视频那样刷着刷着就跑偏了。",
  },
  {
    name: "高女士",
    role: "影视从业者",
    quote:
      "行业里消息本来就杂，这里的梳理至少把时间线排明白了，做判断的时候能少走一点弯路。",
  },
  {
    name: "阿哲",
    role: "夜猫子 · 使用半年",
    quote:
      "凌晨刷也有人在更新，这一点很难得。第二天醒来看时间线，不会被重复的内容淹没。",
  },
  {
    name: "周小满",
    role: "内容创作者",
    quote:
      "写选题的时候会来这里找脉络，它把来龙去脉讲得比较克制，不会为了热闹硬加戏。",
  },
];